import {useEffect,useState} from "react";

import {db} from "../firebase";

import {
collection,
getDocs,
updateDoc,
doc
} from "firebase/firestore";


function Orders(){


const [orders,setOrders]=useState([]);



const getOrders=async()=>{


const snap = await getDocs(

collection(db,"orders")

);



const data=snap.docs.map(item=>(

{
id:item.id,
...item.data()
}

));



setOrders(data);


};




useEffect(()=>{

getOrders();

},[]);





const changeStatus=async(id,status)=>{


await updateDoc(

doc(db,"orders",id),

{

status:status

}

);


getOrders();


};





return(

<div className="orders-page">


<h1>
Orders 📦
</h1>



{

orders.length === 0 ?

<h2>
No Orders Yet
</h2>



:

orders.map(order=>(


<div className="order-card" key={order.id}>


<h2>
Customer:
{order.customer?.name}
</h2>



<p>
Phone:
{order.customer?.phone}
</p>



<p>
Address:
{order.customer?.address}
</p>




<h3>
Products
</h3>


{

order.products?.map(item=>(


<div key={item.id}>


<p>

{item.name}

×

{item.quantity}

</p>


</div>


))


}



<h3>

Total:
${order.total}

</h3>




<select

value={order.status}

onChange={(e)=>changeStatus(order.id,e.target.value)}

>


<option>
Pending
</option>


<option>
Preparing
</option>


<option>
Shipping
</option>


<option>
Delivered
</option>


</select>



</div>


))


}



</div>


);


}


export default Orders;